import gql from 'graphql-tag';
import { business } from './business';

export const short = gql`
  fragment ShortUser on User {
    id
    fullName
    username
    imageUrl
    isMe
    isPending
    lastRemindedAt
  }
`;

export const directoryUser = gql`
  fragment DirectoryUser on User {
    ...ShortUser
    firstName
    isRemoved(businessId: $businessId)
    role(businessId: $businessId)
  }

  ${short}
`;

export const normal = gql`
  fragment User on User {
    ...ShortUser
    firstName
    lastName
    isSuperAdmin
    snoozeUntil
    lastVisitedAt
    notificationSettings
    createdAt
    businesses {
      ...Business
    }
  }

  ${short}
  ${business}
`;

export const profile = gql`
  fragment Profile on User {
    ...ShortUser
    firstName
    lastName
    isSuperAdmin
    snoozeUntil
    lastVisitedAt
    notificationSettings
    createdAt
    businesses {
      ...Business
    }
    email
    phoneNumber
  }

  ${short}
  ${business}
`;

export const businessRole = gql`
  fragment UserBusinessRole on User {
    id
    isBusinessAdmin(businessId: $businessId)
    role(businessId: $businessId)
  }
`;

export const userSummary = gql`
  fragment UserSummary on User {
    id
    fullName
    firstName
    lastName
    imageUrl
  }
`;

export const personalDetails = gql`
  fragment PersonalDetailsUser on User {
    ...ShortUser
    email
    phoneNumber
  }

  ${short}
`;

export const accessLevel = gql`
  fragment AccessLevel on AccessLevel {
    type
    title
    description
  }
`;

export const collectionViewUser = gql`
  fragment CollectionViewUser on User {
    ...ShortUser
    firstName
    lastName
  }

  ${short}
`;

export const unsnoozeUser = gql`
  fragment UnSnoozeUser on User {
    id
    snoozeUntil
  }
`;

export const userGroup = gql`
  fragment UserGroup on UserGroup {
    id
    createdAt
    updatedAt
    name
    businessId
  }
`;

export const userGroupUserAssociation = gql`
  fragment UserGroupUserAssociation on UserGroupUserAssociation {
    userGroupId
    userId
  }
`;
